import gql from 'graphql-tag';

export const getMerchantUsersByAdmin = gql`
  query getMerchantUsersByAdmin($merchantId: Int!) {
    getMerchantUsersByAdmin(merchantId: $merchantId) {
      id
      username
      email
      firstName
      lastName
      telephone
      mobile
      role
      active
      stores {
        id
        name
      }
      regions {
        id
        name
      }
      userView {
        wallet
        transfers
        sendCoins
      }
    }
  }
`;

export const getRegionsByMerchantAdmin = gql`
  query getRegionsByMerchantAdmin($merchantId: Int!) {
    getRegionsByMerchantAdmin(merchantId: $merchantId) {
      id
      name
      stores {
        id
        name
      }
    }
  }
`;

export const getMerchantName = gql`
  query getMerchantName($id: Int!) {
    getUserById(id: $id) {
      id
      username
      businessName
    }
  }
`;
